<template>

    <div>
        <form>
            <div v-for="child in children">
                <div class="form-group row">
                    <label :for="'sel'+child"
                        class="col-sm-3 col-form-label">{{child}}. {{voMsg('quote.child')}}</label>
                    <div class="col-sm-9 align-self-center">
                        <select :id="'sel'+child"
                            :name="'sel'+child"
                            v-model="childrenModel[child]"
                            @change="onChange($event)"
                            class="form-control">


                            <option v-for="a in ages"
                                :value="a">
                                <span v-if="a == 0">{{a}} {{voMsg('quote.years')}}</span>
                                <span v-if="a == 1">{{a}} {{voMsg('quote.year')}}</span>
                                <span v-if="a > 1">{{a}} {{voMsg('quote.years')}}</span>
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </form>
    </div>



</template>
<script>
    import V from 'voUtils/V.js';

    export default {
    	name: 'childrenage',
    	voVueComponent: 'childrenage',
    	data() {
    		return {
    			childrenModel: []
    		}
    	},
    	props: {
    		children: Number,
    		callback: Function
    	},
    	computed: {
    		ages: function() {
    			var ages = [];
    			for (var i = 1; i <= 17; i++) {
    				ages.push(i);
    			}
    			return ages;
    		}
    	},
    	methods: {
    		onChange(event) {

    			let childrenArray = this.childrenModel;
    			let count = 0
    			let childrenAgesArray = [];
    			let childrenAgesString = '';

    			for (let i = 0; i < childrenArray.length; i++) {
    				if (parseInt(childrenArray[i]) >= 0) {
    					//console.log('ArrayValue::', childrenArray[i]);
    					childrenAgesArray.push(childrenArray[i]);
    					count++;
    				}
    			}

    			if (count === this.children) {
    				childrenAgesString = childrenAgesArray.toString();
    				this.callback(childrenAgesString);
    				document.getElementById('children-age-notice1').style.display = 'none';
    				document.getElementById('children-age-notice2').style.display = 'none';
    				document.getElementById('booknowbutton1').disabled = false;
    				document.getElementById('booknowbutton2').disabled = false;
    			} else {
    				document.getElementById('children-age-notice1').style.display = 'block';
    				document.getElementById('children-age-notice2').style.display = 'block';
    				document.getElementById('booknowbutton1').disabled = true;
    				document.getElementById('booknowbutton2').disabled = true;
    			}

    		},
    	},
    	watch: {
    		children: function(newVal, oldVal) {
    			//console.log('Prop changed: ', newVal, ' | was: ', oldVal)
    			this.childrenModel = [];

    		}
    	}
    }
</script>